import gsap from 'gsap';
import { ev, isTablet, isMobile } from '../../../js/utils';
import $ from 'jquery';
import initCustomCursor from '../Cursor';

export default () => {
	const overlayVideo = document.querySelector('[data-video-overlay]');
	let videoOverlayTimeout;
	window.isVideoOverlayShown = false;

	$(overlayVideo).on('click', () => {
		console.log(videoOverlayTimeout);
		clearTimeout(videoOverlayTimeout);
		hideVideoOverlay();
	});

	document.addEventListener('backToVideo', (e) => {
		//console.log('backToVideo');
		if (window.isVideoOverlayShown) {
			if (e.detail?.callback) e.detail.callback();
			ev('resumeVideo');
			ev('showCursor');
		}

		if (!window.isVideoOverlayShown) {
			//console.log('!window.isVideoOverlayShown');
			ev('pauseVideo');
			window.isVideoOverlayShown = true;

			gsap.set(overlayVideo, {
				opacity: 0,
				pointerEvents: 'none',
			});
			$(overlayVideo).show();

			gsap.to(overlayVideo, {
				opacity: 1,
				duration: 0.7,
				ease: 'power2.out',
				pointerEvents: 'auto',
				onComplete: () => {
					hideVideoOverlayAfterTimout(true, e.detail?.callback ? e.detail.callback : false);
				},
			});
		}
	});

	const hideVideoOverlay = () => {
		ev('resumeVideo');
		ev('showCursor');

		// ev('resumeVideo');

		ev('showBurgerBtn', {});

		gsap.to(overlayVideo, {
			opacity: 0,
			duration: 0.7,
			ease: 'power2.out',
			pointerEvents: 'none',
			onComplete: () => {
				initCustomCursor();
			},
		});
	};

	const hideVideoOverlayAfterTimout = (isMuted, callback) => {
		//console.log('hideVideoOverlayAfterTimout');
		videoOverlayTimeout = setTimeout(() => {
			//console.log('resumeVideo hideVideoOverlayAfterTimout');
			if (callback) callback();
			hideVideoOverlay();
		}, 5000);
	};

	function showVideoOverlay(isMuted) {
		$(overlayVideo).show();
		window.isVideoOverlayShown = true;

		gsap.delayedCall(0.5, () => {
			hideVideoOverlayAfterTimout(isMuted);
		});
	}

	document.addEventListener('showVideoOverlay', (e) => {
		if (e.detail.showVideoOverlay) showVideoOverlay(e.detail.isMuted);
	});
};
